<template>
  <div class="tree-options">
    <!-- MULTIPLE OPTIONS tree options for multiple select checkboxes -->
    <div class="label-wrapper" v-if="type=='multiple'">
      <template v-if="parent !== null">
        <div class="form-check" :style="indent" :class="{...labelClasses}">
          <input 
            type="checkbox"
            class="form-check-input"
            :id="'mcs_input_option_'+parentUID+parent[optionValue]"
            :value="parent[optionValue]"
            v-model="checked_options"
            @input="input($event)"
            :disabled="typeof parent.__enabled !== 'undefined'?!parent.__enabled:false"
          >
          <label 
            :for="'mcs_input_option_'+parentUID+parent[optionValue]"
            class="form-check-label">{{ parent[optionLabel] }}
          </label>
          <template v-if="nodes.length > 0" style="font-size: 13px;">
            <span v-show="showChildren" @click="showChildren = !showChildren">
                <i class="fa fa-caret-up fw ml-1"></i>
            </span>
            <span v-show="!showChildren" @click="showChildren = !showChildren">
              <i class="fa fa-caret-down fw ml-1"></i>
            </span>
            <a href="" class="ml-2" @click.prevent="selectAll($event)"> All</a> |
            <a href="" @click.prevent="clearAll($event)">Clear</a>
          </template>
        </div>
      </template>
      <template v-else>
        <a href="" class="ml-2" @click.prevent="selectAll($event)"> All</a> |
        <a href="" @click.prevent="clearAll($event)">Clear</a>
      </template>
    </div>
    <!-- END MULTIPLE -->
    <!-- SINGLE OPTIONS one single option-->
    <div v-else-if="parent !== null">
      <template v-if="typeof parent.__enabled !== 'undefined'?parent.__enabled:true"> 
        <a class="dropdown-item" 
          :id="'mcs_input_option_'+parentUID+parent[optionValue]"
          @click.prevent="onInput(parent[optionValue],parent[optionLabel])"
          :style="indent"
        >{{ parent[optionLabel] }}</a>
      </template>
      <template v-else>
        <span :style="[indent,{background: '#dadada' }]" class="dropdown-item text-muted"> {{ parent[optionLabel] }} </span>
      </template>
    </div>
    <!-- END SINGLE -->
    <tree-options
      v-show="showChildren"
      v-for="(node, index) in nodes"
      :ref="`ref_tree_option_${parentUID}_${_uid}_${node[optionValue]}`"
      :type="type"
      :nodes="node[nodesName]?node[nodesName]:[]"
      :optionValue="optionValue"
      :optionLabel="optionLabel"
      :nodesName="nodesName"
      :parent="node"
      :key="'node_'+_uid+index+node[optionValue]"
      :depth="depth + 1"
      :model="model"
      @input="onInput"
      :parentUID="parentUID"
    >
    </tree-options>
  </div>
</template>

<script>
export default {
  name: 'tree-options',
  props: {
    type: {
      type: String,
      default: 'single'
    },
    optionNodes: {
      type: String,
      default: null
    },
    optionValue: {
      type: String,
      default: null
    },
    optionLabel: {
      type: String,
      default: null
    },
    nodesName: {
      type: String,
      required: true
    },
    model: {
      required: true
    },
    parent: {
      type: Object,
      default: null,
    },
    nodes: {
      type: Array
    },
    depth: {
      type: Number,
      required: true
    },
    parentUID: {
      required: true
    }
  },
  watch: {
    model: function (newVal, oldVal) {
      if (this.type == 'multiple') {
        //if (Array.isArray(newVal)) {
          this.checked_options = newVal;
        /*} else if (typeof newVal == 'string') {
          if (this.parent) {
            let data = newVal.split(",");
            for (let val of data) {
              if (val == this.parent[this.optionValue]) {
                this.checked_options.push(this.parent);
                break;
              }
            }
          }
        } else {
          this.checked_options = [];
        }*/
      } else {
        if (this.parent && this.parent[this.optionValue] == newVal) {
          //this.checked_option = this.parent[this.optionValue];
          this.onInput(this.parent[this.optionValue], this.parent[this.optionLabel]);
        }
      }
    },
    checked_option: function(newVal , oldVal){
      try{document.getElementById(`mcs_input_option_${this.parentUID}${oldVal}`).classList.remove('active');}catch(err){}
      try{document.getElementById(`mcs_input_option_${this.parentUID}${newVal}`).classList.add('active');}catch(err){}
    }
  },
  methods: {
    selectAll() {
      if (this.nodes.length > 0) {
        let nodes = JSON.parse(JSON.stringify(this.nodes));
        if (this.parent !== null) nodes.push(JSON.parse(JSON.stringify(this.parent)));
        this.checked_options.forEach(co => {
          nodes = nodes.filter((node) => {
            return node[this.optionValue] !== co;
          });
        });
        this.checked_options = [...this.checked_options, ...nodes.map(node => node[this.optionValue])];
      }
      this.$emit('input', this.checked_options);
      this.nodes.forEach(node => {
        setTimeout(() => {
          this.$refs[`ref_tree_option_${this.parentUID}_${this._uid}_${node[this.optionValue]}`][0].selectAll();
        }, 45);
      });
    },
    clearAll() {
      if (this.nodes.length > 0) {
        let options = JSON.parse(JSON.stringify(this.checked_options));
        let nodes = JSON.parse(JSON.stringify(this.nodes));
        if (this.parent !== null) nodes.push(JSON.parse(JSON.stringify(this.parent)));
        nodes.forEach(node => {
          options = options.filter((o) => {
            return o != node[this.optionValue];
          });
        });
        this.checked_options = options;
      }
      this.$emit('input', this.checked_options);
      this.nodes.forEach(node => {
        setTimeout(() => {
          this.$refs[`ref_tree_option_${this.parentUID}_${this._uid}_${node[this.optionValue]}`][0].clearAll();
        }, 45);
      });
    },
    input(event) {
      if (event.target.checked) {
        this.checked_options.push(this.parent[this.optionValue]);
      } else {
        this.checked_options = this.checked_options.filter(cp => {
          return cp != this.parent[this.optionValue];
        });
      }
      this.$emit('input', this.checked_options);
    },
    onInput(data, label) {
      this.checked_option = data;
      this.$emit('input', data, label);
    }
  },
  computed: {
    iconClasses() {
      return this.showChildren ? 'fa fa-caret-up fw' : 'fa fa-caret-down fw';
    },
    labelClasses() {
      return {'has-children': this.nodes.length > 0}
    },
    indent() {
      return {transform: `translate(${this.depth * 15}px)`, cursor: 'pointer'}
    },
    indentSelectAll() {
      return {transform: `translate(${(this.depth + 1) * 15}px)`}
    }
  },
  data() {
    return {
      showChildren: true,
      checked_options: this.type == 'multiple' ? this.model : [],
      checked_option: this.type == 'single' ? this.model : null
    }
  }
}
</script>

<style>
.has-children {
  cursor: pointer;
}
</style>
